import { api } from "@/integrations/clients/carAuction/carAuctionClient";

export interface SubmitFeedbackRequest {
  description: string;
  stars: number;
}

export type BugReportDeviceType = "MOBILE" | "TABLET" | "DESKTOP";
export type BugReportOs = "ANDROID" | "IOS" | "WINDOWS";

export interface SubmitBugReportRequest {
  description: string;
  occurredAt: string;
  deviceType: BugReportDeviceType;
  os: BugReportOs;
}

export class FeedbackService {
  static async submitFeedback(data: SubmitFeedbackRequest): Promise<{ id: string }> {
    const response = await api.post<{ success: boolean; data: { id: string } }>(
      "/feedback",
      data
    );
    if (!response.success || !response.data) {
      throw new Error("Failed to submit feedback");
    }
    return response.data;
  }

  static async submitBugReport(data: SubmitBugReportRequest): Promise<{ id: string }> {
    const response = await api.post<{ success: boolean; data: { id: string } }>(
      "/bug-reports",
      data
    );
    if (!response.success || !response.data) {
      throw new Error("Failed to submit bug report");
    }
    return response.data;
  }
}
